import "core-js/modules/es6.array.index-of";
var NON_PIXEL_NUMBER_PROPS = ['column-count', 'font-weight', 'flex-basis', 'flex', 'flex-grow', 'flex-shrink', 'fill-opacity', 'opacity', 'order', 'z-index', 'zoom'];
export function provideUnits(rulePairs, index) {
  var name = rulePairs[index];
  var value = rulePairs[index + 1];

  if (typeof value === 'number') {
    var unit = NON_PIXEL_NUMBER_PROPS.indexOf(name) === -1 ? 'px' : '';
    rulePairs[index + 1] = "" + value + unit;
  }
}